import { FacewashFunction } from "./v1";

export const facewashFunctionOptions = Object.entries(FacewashFunction)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
